import React, { forwardRef, cloneElement } from 'react'
import { List, Datagrid, TextField, EditButton, DeleteButton, ShowButton, useTranslate } from 'react-admin'
import { Paper, Container, Tooltip } from '@mui/material'

const TooltipWrapper = forwardRef(({ children, ...props }, ref) => (
  <div ref={ref}>{cloneElement(children, props)}</div>
))

const MyTooltip = ({ children, ...props }) => (
  <Tooltip placement='top' {...props}>
    <TooltipWrapper>{children}</TooltipWrapper>
  </Tooltip>
)

export const ItemList = (props) => {
  const translate = useTranslate()
  return (
    <>
      <Container className='content'>
        <Paper className='paper_content' /* {...props}  */ /* style={{width: "100%", overflow: "hidden"}} */>
          <List {...props} component='div' /* style={{width: "100%", overflow: "hidden"}} */>
            {/* <div style={{minWidth: 700, overflowX: "auto", width: '100%'}}></div> */}
            <Datagrid rowClick='show'>
              <TextField source='id' label={translate('ra.field.id')} />
              <TextField source='reservation' label={translate('ra.field.reservation')} />
              <TextField source='product' label={translate('ra.field.product')} />
              <TextField source='id_detail' label={translate('ra.field.id_detail')} />
              <MyTooltip title={translate('ra.action.see_details')} aria-label='show'>
                <ShowButton basePath={props.basePath} label='' />
              </MyTooltip>
              <MyTooltip title={translate('ra.action.edit')} aria-label='edit'>
                <EditButton basePath={props.basePath} label='' />
              </MyTooltip>
              <MyTooltip title={translate('ra.action.delete')} aria-label='delete'>
                <DeleteButton basePath={props.basePath} label='' />
              </MyTooltip>
            </Datagrid>
          </List>
        </Paper>
      </Container>
    </>
  )
}
